/* Málaga: comportamiento mínimo. Todo lo demás es CSS. */

(() => {
  const header = document.querySelector('[data-header]');

  // ---- Header: transparente sobre el hero, sólido apenas se scrollea ----
  // Un centinela de 1px en el borde superior avisa cuando sale de pantalla.
  const sentinel = document.querySelector('[data-header-sentinel]');
  if (header && sentinel && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      ([entry]) => header.classList.toggle('is-solid', !entry.isIntersecting),
      { rootMargin: '0px', threshold: 0 }
    );
    io.observe(sentinel);
  } else if (header) {
    header.classList.add('is-solid');
  }

  // ---- Dialogs: menú móvil y buscador ----
  document.querySelectorAll('[data-dialog-open]').forEach((btn) => {
    const dialog = document.getElementById(btn.dataset.dialogOpen);
    if (!dialog) return;
    btn.addEventListener('click', () => {
      dialog.showModal();
      const target = dialog.querySelector('[data-dialog-focus]');
      if (target) target.focus({ preventScroll: true });
    });
  });

  document.querySelectorAll('dialog').forEach((dialog) => {
    dialog.querySelectorAll('[data-dialog-close]').forEach((btn) => {
      btn.addEventListener('click', () => dialog.close());
    });
    // Cerrar al tocar el fondo oscurecido
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
  });

  // ---- Mega-menú (desktop) ----
  const nav = document.querySelector('[data-mega-nav]');
  if (header && nav) {
    const desktop = window.matchMedia('(min-width: 1024px)');
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const items = [...nav.querySelectorAll('[data-mega]')].filter((li) =>
      li.querySelector('[data-mega-panel]')
    );
    let openItem = null;
    let openTimer = 0;
    let closeTimer = 0;

    const setState = (li, open) => {
      const toggle = li.querySelector('[data-mega-toggle]');
      const panel = li.querySelector('[data-mega-panel]');
      li.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
    };

    const closeAll = () => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (!openItem) return;
      setState(openItem, false);
      openItem = null;
      header.classList.remove('is-open');
    };

    const open = (li) => {
      clearTimeout(closeTimer);
      if (openItem === li) return;
      if (openItem) setState(openItem, false);
      openItem = li;
      setState(li, true);
      header.classList.add('is-open');
    };

    items.forEach((li) => {
      const link = li.querySelector('[data-mega-link]');
      const toggle = li.querySelector('[data-mega-toggle]');

      // Hover con intención (solo mouse)
      li.addEventListener('pointerenter', (e) => {
        if (!desktop.matches || !canHover.matches || e.pointerType === 'touch') return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => open(li), 100);
      });
      li.addEventListener('pointerleave', () => clearTimeout(openTimer));

      // Click / teclado en el toggle
      toggle.addEventListener('click', () => {
        if (openItem === li) closeAll();
        else open(li);
      });

      // Touch sin hover (tablet): primer tap abre, segundo navega
      link.addEventListener('click', (e) => {
        if (!desktop.matches || canHover.matches) return;
        if (openItem !== li) {
          e.preventDefault();
          open(li);
        }
      });
    });

    // Salir del header con el mouse cierra (con un pequeño margen)
    header.addEventListener('pointerleave', (e) => {
      if (e.pointerType === 'touch') return;
      closeTimer = setTimeout(closeAll, 150);
    });
    header.addEventListener('pointerenter', () => clearTimeout(closeTimer));

    // Escape cierra y devuelve el foco al toggle
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !openItem) return;
      const toggle = openItem.querySelector('[data-mega-toggle]');
      closeAll();
      toggle.focus();
    });

    // Tab fuera del header o click fuera cierran
    header.addEventListener('focusout', (e) => {
      if (openItem && !header.contains(e.relatedTarget)) closeAll();
    });
    document.addEventListener('pointerdown', (e) => {
      if (openItem && !header.contains(e.target)) closeAll();
    });

    // Cambiar de desktop a móvil cierra
    desktop.addEventListener('change', closeAll);
  }

  // ---- Contadores del header ----
  // El del carrito lo actualiza product.js al agregar; el de favoritos, collection.js
  // al tocar un corazón. Acá solo se pinta el globito sobre el ícono.
  const setCount = (n, badgeSel) => {
    document.querySelectorAll(badgeSel).forEach((el) => {
      el.textContent = n;
      el.hidden = n === 0;
    });
  };

  document.addEventListener('malaga:cart', (e) => setCount(e.detail, '[data-cart-count]'));

  const syncWishBadge = (n) => setCount(n, '[data-wishlist-badge]');

  document.addEventListener('malaga:wishlist', (e) => syncWishBadge(e.detail));

  try {
    syncWishBadge(JSON.parse(localStorage.getItem('malaga:wishlist') || '[]').length);
  } catch (e) {
    /* sin storage: el contador queda en cero */
  }

  // ---- Fade suave de imágenes al cargar (también las que inserta JS después) ----
  const reveal = (img) => img.classList.add('is-loaded');
  const bindFade = (img) => {
    if (img.dataset.fadeBound) return;
    img.dataset.fadeBound = '1';
    if (img.complete && img.naturalWidth > 0) reveal(img);
    else img.addEventListener('load', () => reveal(img), { once: true });
  };
  document.querySelectorAll('img[data-fade]').forEach(bindFade);
  if ('MutationObserver' in window) {
    new MutationObserver((records) => {
      records.forEach((r) =>
        r.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('img[data-fade]')) bindFade(n);
          n.querySelectorAll && n.querySelectorAll('img[data-fade]').forEach(bindFade);
        })
      );
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
